var _regeneratorRuntime = require("/workspaces/emuto-demo/node_modules/@babel/runtime/regenerator");

!function (t, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n(require("./../../buffer/index.js")) : "function" == typeof define && define.amd ? define(["./../../buffer/index.js"], n) : "object" == typeof exports ? exports.emuto = n(require("./../../buffer/index.js")) : t.emuto = n(t["./../../buffer/index.js"]);
}(window, function (__WEBPACK_EXTERNAL_MODULE__18__) {
  return function (t) {
    var n = {};

    function r(e) {
      if (n[e]) return n[e].exports;
      var u = n[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return t[e].call(u.exports, u, u.exports, r), u.l = !0, u.exports;
    }

    return r.m = t, r.c = n, r.d = function (t, n, e) {
      r.o(t, n) || Object.defineProperty(t, n, {
        enumerable: !0,
        get: e
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, n) {
      if (1 & n && (t = r(t)), 8 & n) return t;
      if (4 & n && "object" == typeof t && t && t.__esModule) return t;
      var e = Object.create(null);
      if (r.r(e), Object.defineProperty(e, "default", {
        enumerable: !0,
        value: t
      }), 2 & n && "string" != typeof t) for (var u in t) {
        r.d(e, u, function (n) {
          return t[n];
        }.bind(null, u));
      }
      return e;
    }, r.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(n, "a", n), n;
    }, r.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, r.p = "", r(r.s = 17);
  }([function (t, n, r) {
    (function (n) {
      "undefined" != typeof self && self, t.exports = function (t) {
        var n = {};

        function r(e) {
          if (n[e]) return n[e].exports;
          var u = n[e] = {
            i: e,
            l: !1,
            exports: {}
          };
          return t[e].call(u.exports, u, u.exports, r), u.l = !0, u.exports;
        }

        return r.m = t, r.c = n, r.d = function (t, n, e) {
          r.o(t, n) || Object.defineProperty(t, n, {
            configurable: !1,
            enumerable: !0,
            get: e
          });
        }, r.r = function (t) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, r.n = function (t) {
          var n = t && t.__esModule ? function () {
            return t.default;
          } : function () {
            return t;
          };
          return r.d(n, "a", n), n;
        }, r.o = function (t, n) {
          return Object.prototype.hasOwnProperty.call(t, n);
        }, r.p = "", r(r.s = 0);
      }([function (t, r, e) {
        "use strict";

        function u(t) {
          if (!(this instanceof u)) return new u(t);
          this._ = t;
        }

        var o = u.prototype;

        function i(t, n) {
          for (var r = 0; r < t; r++) {
            n(r);
          }
        }

        function a(t, n, r) {
          return function (t, n) {
            i(n.length, function (r) {
              t(n[r], r, n);
            });
          }(function (r, e, u) {
            n = t(n, r, e, u);
          }, r), n;
        }

        function c(t, n) {
          return a(function (n, r, e, u) {
            return n.concat([t(r, e, u)]);
          }, [], n);
        }

        function f(t, r) {
          var e = {
            v: 0,
            buf: r
          };
          return i(t, function () {
            var t;
            e = {
              v: e.v << 1 | (t = e.buf, t[0] >> 7),
              buf: function (t) {
                var r = a(function (t, r, e, u) {
                  return t.concat(e === u.length - 1 ? n.from([r, 0]).readUInt16BE(0) : u.readUInt16BE(e));
                }, [], t);
                return n.from(c(function (t) {
                  return (t << 1 & 65535) >> 8;
                }, r));
              }(e.buf)
            };
          }), e;
        }

        function l() {
          return void 0 !== n;
        }

        function s() {
          if (!l()) throw new Error("Buffer global does not exist; please use webpack if you need to parse Buffers in the browser.");
        }

        function p(t) {
          s();
          var n = a(function (t, n) {
            return t + n;
          }, 0, t);
          if (n % 8 != 0) throw new Error("The bits [" + t.join(", ") + "] add up to " + n + " which is not an even number of bytes; the total should be divisible by 8");
          var r,
              e = n / 8,
              o = (r = function r(t) {
            return t > 48;
          }, a(function (t, n) {
            return t || (r(n) ? n : t);
          }, null, t));
          if (o) throw new Error(o + " bit range requested exceeds 48 bit (6 byte) Number max.");
          return new u(function (n, r) {
            var u = e + r;
            return u > n.length ? O(r, e.toString() + " bytes") : w(u, a(function (t, n) {
              var r = f(n, t.buf);
              return {
                coll: t.coll.concat(r.v),
                buf: r.buf
              };
            }, {
              coll: [],
              buf: n.slice(r, u)
            }, t).coll);
          });
        }

        function v(t, n) {
          return new u(function (r, e) {
            return s(), e + n > r.length ? O(e, n + " bytes for " + t) : w(e + n, r.slice(e, e + n));
          });
        }

        function h(t, n) {
          if ("number" != typeof (r = n) || Math.floor(r) !== r || n < 0 || n > 6) throw new Error(t + " requires integer length in range [0, 6].");
          var r;
        }

        function d(t) {
          return h("uintBE", t), v("uintBE(" + t + ")", t).map(function (n) {
            return n.readUIntBE(0, t);
          });
        }

        function y(t) {
          return h("uintLE", t), v("uintLE(" + t + ")", t).map(function (n) {
            return n.readUIntLE(0, t);
          });
        }

        function b(t) {
          return h("intBE", t), v("intBE(" + t + ")", t).map(function (n) {
            return n.readIntBE(0, t);
          });
        }

        function g(t) {
          return h("intLE", t), v("intLE(" + t + ")", t).map(function (n) {
            return n.readIntLE(0, t);
          });
        }

        function m(t) {
          return t instanceof u;
        }

        function _(t) {
          return "[object Array]" === {}.toString.call(t);
        }

        function j(t) {
          return l() && n.isBuffer(t);
        }

        function w(t, n) {
          return {
            status: !0,
            index: t,
            value: n,
            furthest: -1,
            expected: []
          };
        }

        function O(t, n) {
          return _(n) || (n = [n]), {
            status: !1,
            index: -1,
            value: null,
            furthest: t,
            expected: n
          };
        }

        function x(t, n) {
          if (!n) return t;
          if (t.furthest > n.furthest) return t;
          var r = t.furthest === n.furthest ? function (t, n) {
            for (var r = {}, e = 0; e < t.length; e++) {
              r[t[e]] = !0;
            }

            for (var u = 0; u < n.length; u++) {
              r[n[u]] = !0;
            }

            var o = [];

            for (var i in r) {
              ({}).hasOwnProperty.call(r, i) && o.push(i);
            }

            return o.sort(), o;
          }(t.expected, n.expected) : n.expected;
          return {
            status: t.status,
            index: t.index,
            value: t.value,
            furthest: n.furthest,
            expected: r
          };
        }

        function E(t, n) {
          if (j(t)) return {
            offset: n,
            line: -1,
            column: -1
          };
          var r = t.slice(0, n).split("\n");
          return {
            offset: n,
            line: r.length,
            column: r[r.length - 1].length + 1
          };
        }

        function A(t) {
          if (!m(t)) throw new Error("not a parser: " + t);
        }

        function S(t, n) {
          return "string" == typeof t ? t.charAt(n) : t[n];
        }

        function P(t) {
          if ("number" != typeof t) throw new Error("not a number: " + t);
        }

        function B(t) {
          if ("function" != typeof t) throw new Error("not a function: " + t);
        }

        function z(t) {
          if ("string" != typeof t) throw new Error("not a string: " + t);
        }

        var k = 2,
            M = 3,
            I = 8,
            q = 5 * I,
            L = 4 * I,
            T = "  ";

        function F(t, n) {
          return new Array(n + 1).join(t);
        }

        function D(t, n, r) {
          var e = n - t.length;
          return e <= 0 ? t : F(r, e) + t;
        }

        function U(t, n, r, e) {
          return {
            from: t - n > 0 ? t - n : 0,
            to: t + r > e ? e : t + r
          };
        }

        function $(t, n) {
          var r,
              e,
              u,
              o,
              i,
              f = n.index,
              l = f.offset,
              s = 1;
          if (l === t.length) return "Got the end of the input";

          if (j(t)) {
            var p = l - l % I,
                v = l - p,
                h = U(p, q, L + I, t.length),
                d = c(function (t) {
              return c(function (t) {
                return D(t.toString(16), 2, "0");
              }, t);
            }, function (t, n) {
              var r = t.length,
                  e = [],
                  u = 0;
              if (r <= n) return [t.slice()];

              for (var o = 0; o < r; o++) {
                e[u] || e.push([]), e[u].push(t[o]), (o + 1) % n == 0 && u++;
              }

              return e;
            }(t.slice(h.from, h.to).toJSON().data, I));
            o = function (t) {
              return 0 === t.from && 1 === t.to ? {
                from: t.from,
                to: t.to
              } : {
                from: t.from / I,
                to: Math.floor(t.to / I)
              };
            }(h), e = p / I, r = 3 * v, v >= 4 && (r += 1), s = 2, u = c(function (t) {
              return t.length <= 4 ? t.join(" ") : t.slice(0, 4).join(" ") + "  " + t.slice(4).join(" ");
            }, d), (i = (8 * (o.to > 0 ? o.to - 1 : o.to)).toString(16).length) < 2 && (i = 2);
          } else {
            var y = t.split(/\r\n|[\n\r\u2028\u2029]/);
            r = f.column - 1, e = f.line - 1, o = U(e, k, M, y.length), u = y.slice(o.from, o.to), i = o.to.toString().length;
          }

          var b = e - o.from;
          return j(t) && (i = (8 * (o.to > 0 ? o.to - 1 : o.to)).toString(16).length) < 2 && (i = 2), a(function (n, e, u) {
            var a,
                c = u === b,
                f = c ? "> " : T;
            return a = j(t) ? D((8 * (o.from + u)).toString(16), i, "0") : D((o.from + u + 1).toString(), i, " "), [].concat(n, [f + a + " | " + e], c ? [T + F(" ", i) + " | " + D("", r, " ") + F("^", s)] : []);
          }, [], u).join("\n");
        }

        function C(t, n) {
          return ["\n", "-- PARSING FAILED " + F("-", 50), "\n\n", $(t, n), "\n\n", (r = n.expected, 1 === r.length ? "Expected:\n\n" + r[0] : "Expected one of the following: \n\n" + r.join(", ")), "\n"].join("");
          var r;
        }

        function R(t) {
          var n = "" + t;
          return n.slice(n.lastIndexOf("/") + 1);
        }

        function N() {
          for (var t = [].slice.call(arguments), n = t.length, r = 0; r < n; r += 1) {
            A(t[r]);
          }

          return u(function (r, e) {
            for (var u, o = new Array(n), i = 0; i < n; i += 1) {
              if (!(u = x(t[i]._(r, e), u)).status) return u;
              o[i] = u.value, e = u.index;
            }

            return x(w(e, o), u);
          });
        }

        function W() {
          var t = [].slice.call(arguments);
          if (0 === t.length) throw new Error("seqMap needs at least one argument");
          var n = t.pop();
          return B(n), N.apply(null, t).map(function (t) {
            return n.apply(null, t);
          });
        }

        function K() {
          var t = [].slice.call(arguments),
              n = t.length;
          if (0 === n) return H("zero alternates");

          for (var r = 0; r < n; r += 1) {
            A(t[r]);
          }

          return u(function (n, r) {
            for (var e, u = 0; u < t.length; u += 1) {
              if ((e = x(t[u]._(n, r), e)).status) return e;
            }

            return e;
          });
        }

        function J(t, n) {
          return Z(t, n).or(X([]));
        }

        function Z(t, n) {
          return A(t), A(n), W(t, n.then(t).many(), function (t, n) {
            return [t].concat(n);
          });
        }

        function G(t) {
          z(t);
          var n = "'" + t + "'";
          return u(function (r, e) {
            var u = e + t.length,
                o = r.slice(e, u);
            return o === t ? w(u, o) : O(e, n);
          });
        }

        function V(t, n) {
          !function (t) {
            if (!(t instanceof RegExp)) throw new Error("not a regexp: " + t);

            for (var n = R(t), r = 0; r < n.length; r++) {
              var e = n.charAt(r);
              if ("i" !== e && "m" !== e && "u" !== e) throw new Error('unsupported regexp flag "' + e + '": ' + t);
            }
          }(t), arguments.length >= 2 ? P(n) : n = 0;

          var r = function (t) {
            return RegExp("^(?:" + t.source + ")", R(t));
          }(t),
              e = "" + t;

          return u(function (t, u) {
            var o = r.exec(t.slice(u));

            if (o) {
              if (0 <= n && n <= o.length) {
                var i = o[0],
                    a = o[n];
                return w(u + i.length, a);
              }

              return O(u, "valid match group (0 to " + o.length + ") in " + e);
            }

            return O(u, e);
          });
        }

        function X(t) {
          return u(function (n, r) {
            return w(r, t);
          });
        }

        function H(t) {
          return u(function (n, r) {
            return O(r, t);
          });
        }

        function Q(t) {
          if (m(t)) return u(function (n, r) {
            var e = t._(n, r);

            return e.index = r, e.value = "", e;
          });
          if ("string" == typeof t) return Q(G(t));
          if (t instanceof RegExp) return Q(V(t));
          throw new Error("not a string, regexp, or parser: " + t);
        }

        function Y(t) {
          return A(t), u(function (n, r) {
            var e = t._(n, r),
                u = n.slice(r, e.index);

            return e.status ? O(r, 'not "' + u + '"') : w(r, null);
          });
        }

        function tt(t) {
          return B(t), u(function (n, r) {
            var e = S(n, r);
            return r < n.length && t(e) ? w(r + 1, e) : O(r, "a character/byte matching " + t);
          });
        }

        function nt(t, n) {
          arguments.length < 2 && (n = t, t = void 0);
          var r = u(function (t, e) {
            return r._ = n()._, r._(t, e);
          });
          return t ? r.desc(t) : r;
        }

        function rt() {
          return H("fantasy-land/empty");
        }

        o.parse = function (t) {
          if ("string" != typeof t && !j(t)) throw new Error(".parse must be called with a string or Buffer as its argument");

          var n = this.skip(it)._(t, 0);

          return n.status ? {
            status: !0,
            value: n.value
          } : {
            status: !1,
            index: E(t, n.furthest),
            expected: n.expected
          };
        }, o.tryParse = function (t) {
          var n = this.parse(t);
          if (n.status) return n.value;
          var r = C(t, n),
              e = new Error(r);
          throw e.type = "ParsimmonError", e.result = n, e;
        }, o.assert = function (t, n) {
          return this.chain(function (r) {
            return t(r) ? X(r) : H(n);
          });
        }, o.or = function (t) {
          return K(this, t);
        }, o.trim = function (t) {
          return this.wrap(t, t);
        }, o.wrap = function (t, n) {
          return W(t, this, n, function (t, n) {
            return n;
          });
        }, o.thru = function (t) {
          return t(this);
        }, o.then = function (t) {
          return A(t), N(this, t).map(function (t) {
            return t[1];
          });
        }, o.many = function () {
          var t = this;
          return u(function (n, r) {
            for (var e = [], u = void 0;;) {
              if (!(u = x(t._(n, r), u)).status) return x(w(r, e), u);
              if (r === u.index) throw new Error("infinite loop detected in .many() parser --- calling .many() on a parser which can accept zero characters is usually the cause");
              r = u.index, e.push(u.value);
            }
          });
        }, o.tieWith = function (t) {
          return z(t), this.map(function (n) {
            if (function (t) {
              if (!_(t)) throw new Error("not an array: " + t);
            }(n), n.length) {
              z(n[0]);

              for (var r = n[0], e = 1; e < n.length; e++) {
                z(n[e]), r += t + n[e];
              }

              return r;
            }

            return "";
          });
        }, o.tie = function () {
          return this.tieWith("");
        }, o.times = function (t, n) {
          var r = this;
          return arguments.length < 2 && (n = t), P(t), P(n), u(function (e, u) {
            for (var o = [], i = void 0, a = void 0, c = 0; c < t; c += 1) {
              if (a = x(i = r._(e, u), a), !i.status) return a;
              u = i.index, o.push(i.value);
            }

            for (; c < n && (a = x(i = r._(e, u), a), i.status); c += 1) {
              u = i.index, o.push(i.value);
            }

            return x(w(u, o), a);
          });
        }, o.result = function (t) {
          return this.map(function () {
            return t;
          });
        }, o.atMost = function (t) {
          return this.times(0, t);
        }, o.atLeast = function (t) {
          return W(this.times(t), this.many(), function (t, n) {
            return t.concat(n);
          });
        }, o.map = function (t) {
          B(t);
          var n = this;
          return u(function (r, e) {
            var u = n._(r, e);

            return u.status ? x(w(u.index, t(u.value)), u) : u;
          });
        }, o.contramap = function (t) {
          B(t);
          var n = this;
          return u(function (r, e) {
            var u = n.parse(t(r.slice(e)));
            return u.status ? w(e + r.length, u.value) : u;
          });
        }, o.promap = function (t, n) {
          return B(t), B(n), this.contramap(t).map(n);
        }, o.skip = function (t) {
          return N(this, t).map(function (t) {
            return t[0];
          });
        }, o.mark = function () {
          return W(et, this, et, function (t, n, r) {
            return {
              start: t,
              value: n,
              end: r
            };
          });
        }, o.node = function (t) {
          return W(et, this, et, function (n, r, e) {
            return {
              name: t,
              value: r,
              start: n,
              end: e
            };
          });
        }, o.sepBy = function (t) {
          return J(this, t);
        }, o.sepBy1 = function (t) {
          return Z(this, t);
        }, o.lookahead = function (t) {
          return this.skip(Q(t));
        }, o.notFollowedBy = function (t) {
          return this.skip(Y(t));
        }, o.desc = function (t) {
          _(t) || (t = [t]);
          var n = this;
          return u(function (r, e) {
            var u = n._(r, e);

            return u.status || (u.expected = t), u;
          });
        }, o.fallback = function (t) {
          return this.or(X(t));
        }, o.ap = function (t) {
          return W(t, this, function (t, n) {
            return t(n);
          });
        }, o.chain = function (t) {
          var n = this;
          return u(function (r, e) {
            var u = n._(r, e);

            return u.status ? x(t(u.value)._(r, u.index), u) : u;
          });
        }, o.concat = o.or, o.empty = rt, o.of = X, o["fantasy-land/ap"] = o.ap, o["fantasy-land/chain"] = o.chain, o["fantasy-land/concat"] = o.concat, o["fantasy-land/empty"] = o.empty, o["fantasy-land/of"] = o.of, o["fantasy-land/map"] = o.map;
        var et = u(function (t, n) {
          return w(n, E(t, n));
        }),
            ut = u(function (t, n) {
          return n >= t.length ? O(n, "any character/byte") : w(n + 1, S(t, n));
        }),
            ot = u(function (t, n) {
          return w(t.length, t.slice(n));
        }),
            it = u(function (t, n) {
          return n < t.length ? O(n, "EOF") : w(n, null);
        }),
            at = V(/[0-9]/).desc("a digit"),
            ct = V(/[0-9]*/).desc("optional digits"),
            ft = V(/[a-z]/i).desc("a letter"),
            lt = V(/[a-z]*/i).desc("optional letters"),
            st = V(/\s*/).desc("optional whitespace"),
            pt = V(/\s+/).desc("whitespace"),
            vt = G("\r"),
            ht = G("\n"),
            dt = G("\r\n"),
            yt = K(dt, ht, vt).desc("newline"),
            bt = K(yt, it);
        u.all = ot, u.alt = K, u.any = ut, u.cr = vt, u.createLanguage = function (t) {
          var n = {};

          for (var r in t) {
            ({}).hasOwnProperty.call(t, r) && function (r) {
              n[r] = nt(function () {
                return t[r](n);
              });
            }(r);
          }

          return n;
        }, u.crlf = dt, u.custom = function (t) {
          return u(t(w, O));
        }, u.digit = at, u.digits = ct, u.empty = rt, u.end = bt, u.eof = it, u.fail = H, u.formatError = C, u.index = et, u.isParser = m, u.lazy = nt, u.letter = ft, u.letters = lt, u.lf = ht, u.lookahead = Q, u.makeFailure = O, u.makeSuccess = w, u.newline = yt, u.noneOf = function (t) {
          return tt(function (n) {
            return t.indexOf(n) < 0;
          }).desc("none of '" + t + "'");
        }, u.notFollowedBy = Y, u.of = X, u.oneOf = function (t) {
          for (var n = t.split(""), r = 0; r < n.length; r++) {
            n[r] = "'" + n[r] + "'";
          }

          return tt(function (n) {
            return t.indexOf(n) >= 0;
          }).desc(n);
        }, u.optWhitespace = st, u.Parser = u, u.range = function (t, n) {
          return tt(function (r) {
            return t <= r && r <= n;
          }).desc(t + "-" + n);
        }, u.regex = V, u.regexp = V, u.sepBy = J, u.sepBy1 = Z, u.seq = N, u.seqMap = W, u.seqObj = function () {
          for (var t, n = {}, r = 0, e = (t = arguments, Array.prototype.slice.call(t)), o = e.length, i = 0; i < o; i += 1) {
            var a = e[i];

            if (!m(a)) {
              if (_(a) && 2 === a.length && "string" == typeof a[0] && m(a[1])) {
                var c = a[0];
                if (Object.prototype.hasOwnProperty.call(n, c)) throw new Error("seqObj: duplicate key " + c);
                n[c] = !0, r++;
                continue;
              }

              throw new Error("seqObj arguments must be parsers or [string, parser] array pairs.");
            }
          }

          if (0 === r) throw new Error("seqObj expects at least one named parser, found zero");
          return u(function (t, n) {
            for (var r, u = {}, i = 0; i < o; i += 1) {
              var a, c;
              if (_(e[i]) ? (a = e[i][0], c = e[i][1]) : (a = null, c = e[i]), !(r = x(c._(t, n), r)).status) return r;
              a && (u[a] = r.value), n = r.index;
            }

            return x(w(n, u), r);
          });
        }, u.string = G, u.succeed = X, u.takeWhile = function (t) {
          return B(t), u(function (n, r) {
            for (var e = r; e < n.length && t(S(n, e));) {
              e++;
            }

            return w(e, n.slice(r, e));
          });
        }, u.test = tt, u.whitespace = pt, u["fantasy-land/empty"] = rt, u["fantasy-land/of"] = X, u.Binary = {
          bitSeq: p,
          bitSeqObj: function bitSeqObj(t) {
            s();
            var n = {},
                r = 0,
                e = c(function (t) {
              if (_(t)) {
                var e = t;
                if (2 !== e.length) throw new Error("[" + e.join(", ") + "] should be length 2, got length " + e.length);
                if (z(e[0]), P(e[1]), Object.prototype.hasOwnProperty.call(n, e[0])) throw new Error("duplicate key in bitSeqObj: " + e[0]);
                return n[e[0]] = !0, r++, e;
              }

              return P(t), [null, t];
            }, t);
            if (r < 1) throw new Error("bitSeqObj expects at least one named pair, got [" + t.join(", ") + "]");
            var u = c(function (t) {
              return t[0];
            }, e);
            return p(c(function (t) {
              return t[1];
            }, e)).map(function (t) {
              return a(function (t, n) {
                return null !== n[0] && (t[n[0]] = n[1]), t;
              }, {}, c(function (n, r) {
                return [n, t[r]];
              }, u));
            });
          },
          byte: function byte(t) {
            if (s(), P(t), t > 255) throw new Error("Value specified to byte constructor (" + t + "=0x" + t.toString(16) + ") is larger in value than a single byte.");
            var n = (t > 15 ? "0x" : "0x0") + t.toString(16);
            return u(function (r, e) {
              var u = S(r, e);
              return u === t ? w(e + 1, u) : O(e, n);
            });
          },
          buffer: function buffer(t) {
            return v("buffer", t).map(function (t) {
              return n.from(t);
            });
          },
          encodedString: function encodedString(t, n) {
            return v("string", n).map(function (n) {
              return n.toString(t);
            });
          },
          uintBE: d,
          uint8BE: d(1),
          uint16BE: d(2),
          uint32BE: d(4),
          uintLE: y,
          uint8LE: y(1),
          uint16LE: y(2),
          uint32LE: y(4),
          intBE: b,
          int8BE: b(1),
          int16BE: b(2),
          int32BE: b(4),
          intLE: g,
          int8LE: g(1),
          int16LE: g(2),
          int32LE: g(4),
          floatBE: v("floatBE", 4).map(function (t) {
            return t.readFloatBE(0);
          }),
          floatLE: v("floatLE", 4).map(function (t) {
            return t.readFloatLE(0);
          }),
          doubleBE: v("doubleBE", 8).map(function (t) {
            return t.readDoubleBE(0);
          }),
          doubleLE: v("doubleLE", 8).map(function (t) {
            return t.readDoubleLE(0);
          })
        }, t.exports = u;
      }]);
    }).call(this, r(18).Buffer);
  }, function (t, n, r) {
    "use strict";

    var e = r(0),
        u = r.n(e),
        o = u.a.regexp(/[^\n]*/).wrap(u.a.alt(u.a.string("//"), u.a.string("#")), u.a.string("\n")),
        i = u.a.regexp(/[ \n]*/);
    n.a = o.sepBy(i).trim(i);
  }, function (t, n, r) {
    "use strict";

    r.r(n);

    function e(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var u = function u(t) {
      return (0, r(2).default)(t);
    },
        o = function o(t) {
      return "simpleList" === t.name ? function (t) {
        return "[".concat(t.value.map(u).join(", "), "]");
      }(t) : u(t.value);
    },
        i = function i(t) {
      var n = t.value;
      return "[]".concat(n.reduce(function (t, n) {
        return "".concat(t, ".concat(_.__spread__(").concat(o(n), "))");
      }, ""));
    };

    n.default = function t(n) {
      switch (n.name) {
        case "primitive":
          return n.value;

        case "variable":
          return function (t) {
            var n = t.value;
            return "$" === n ? "input" : "_.get('".concat(n.slice(1), "')");
          }(n);

        case "tuple":
          return function (t) {
            var n,
                u,
                o,
                i = t.value,
                a = r(2).default;
            return n = e(i.map(a), 2), u = n[0], o = n[1], "[".concat(u, ",").concat(o, "]");
          }(n);

        case "inputProp":
          return function (t) {
            var n = t.value;
            return "input.".concat(n.slice(1));
          }(n);

        case "list":
          return i(n);

        case "pipe":
          return function (t) {
            var n = t.value,
                e = r(2).default,
                u = e(n.left),
                o = e(n.right);
            return "(function (input) {return ".concat(o, "})(").concat(u, ")");
          }(n);

        case "valueProp":
          return function (t) {
            return function (n) {
              var r = n.value;
              return r.optional ? "_.__opt__(".concat(t(r.left), ", function(x) {return x").concat(r.right, "})") : "".concat(t(r.left)).concat(r.right);
            };
          }(t)(n);

        case "object":
          return function (t) {
            var n = t.value;
            return "(_.objectify(".concat((0, r(2).default)({
              name: "list",
              value: n
            }), "))");
          }(n);

        case "parentheses":
          return function (t) {
            var n = t.value;
            return "(".concat((0, r(2).default)(n), ")");
          }(n);

        case "projection":
          return function (t) {
            return function (n) {
              var r = n.value;
              return "_.projection(".concat(t(r.left), ", ").concat(t(r.right), ", ").concat(r.optional ? "true" : "false", ")");
            };
          }(t)(n);

        case "objectProjection":
          return function (t) {
            return function (n) {
              var r = n.value;
              return "_.__objectProjection__(".concat(t(r.left), ", ").concat(JSON.stringify(r.right), ", ").concat(r.optional ? "true" : "false", ", _)");
            };
          }(t)(n);

        case "functionCall":
          return function (t) {
            return function (n) {
              var r = n.value;
              return r.right ? "_.".concat(r.left.value, "(").concat(t(r.right), ")(input)") : "_.".concat(r.left.value, "(input)");
            };
          }(t)(n);

        case "lambda":
          return function (t) {
            var n = t.value;
            return "(function(".concat(n.variable, ") {").concat("input" === n.variable ? "" : "_ = _.__assign__('".concat(n.variable, "', ").concat(n.variable, ", _); "), "return ").concat((0, r(2).default)(n.definition), "})");
          }(n);

        case "binaryOperation":
          return function (t) {
            var n = t.value;
            return "".concat(n.map(function (t) {
              return (0, r(2).default)(t);
            }).join(""));
          }(n);

        case "unaryOperation":
          return function (t) {
            var n = t.value,
                e = r(2).default;
            return "(".concat(n.operator.value, "(").concat(e(n.operand), "))");
          }(n);

        case "assignment":
          return function (t) {
            return function (n) {
              var r,
                  e = n.value,
                  u = function u(n) {
                return "_ = _.__assign__('".concat(n[0].value, "', (").concat(t(n[1]), "), _)");
              };

              return "((function() {".concat((r = e.assignments, r.map(u).join("; ")), "; return (").concat(t(e.program), ")})())");
            };
          }(t)(n);

        case "ternary":
          return function (t) {
            var n = t.value,
                e = r(2).default;
            return "((".concat(e(n.middle), ") ? (").concat(e(n.left), ") : (").concat(e(n.right), "))");
          }(n);

        default:
          throw new Error("Unknown node name '".concat(n.name, "'"));
      }
    };
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    var e = r(0),
        u = r.n(e);

    function o(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    n.default = u.a.lazy(function () {
      var t = r(9).default;
      return u.a.alt(u.a.seq(t, u.a.regexp(/\s*:\s*/).then(t).atMost(1)).map(function (t) {
        var n = o(t, 2),
            r = n[0],
            e = n[1];
        return 1 === e.length ? {
          name: "tuple",
          value: [r, e[0]]
        } : r;
      }));
    });
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    var e = r(0),
        u = r.n(e);
    n.default = u.a.regexp(/[a-zA-Z][0-9a-zA-Z_$]*/i).chain(function (t) {
      return ["null", "false", "true", "if", "each"].indexOf(t) < 0 ? u.a.of(t) : u.a.fail("identifier but got keyword ".concat(t));
    }).map(function (t) {
      return {
        name: "identifier",
        value: t
      };
    }).desc("identifier");
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    var e = r(0),
        u = r.n(e),
        o = u.a.lazy(function () {
      return r(19).default.sepBy1(u.a.regexp(/\s*\|\s*/)).map(function (t) {
        return t.slice(1).reduce(function (t, n) {
          return {
            name: "pipe",
            value: {
              left: t,
              right: n
            }
          };
        }, t[0]);
      });
    }),
        i = r(9),
        a = r(4),
        c = r(3),
        f = r(1);

    function l(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var s = u.a.seq(u.a.string("$").then(a.default), u.a.string("=").trim(f.a).then(i.default)),
        p = u.a.sepBy(s, f.a),
        v = u.a.seq(c.default, u.a.string("where").trim(f.a).then(p)).map(function (t) {
      var n = l(t, 2);
      return {
        program: n[0],
        assignments: n[1]
      };
    }).node("assignment").desc("assignment");
    n.default = u.a.alt(v, o).trim(f.a).map(function (t) {
      return t;
    });
  }, function (t, n, r) {
    "use strict";

    r.d(n, "a", function () {
      return o;
    });
    var e = r(0),
        u = r.n(e),
        o = new RegExp("(".concat(/("(((?=\\)\\(["'\\\/bfnrt]|u[0-9a-fA-F]{4}))|[^"\\\0-\x1F\x7F]+)*")/.source, "|").concat(/('(((?=\\)\\(['"\\\/bfnrt]|u[0-9a-fA-F]{4}))|[^'\\\0-\x1F\x7F]+)*')/.source, ")")),
        i = [].concat(["null", "true", "false"], [o.source, /(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?/.source]);
    n.b = u.a.regex(new RegExp("(".concat(i.join("|"), ")"))).map(function (t) {
      return {
        name: "primitive",
        value: t
      };
    });
  }, function (t, n, r) {
    "use strict";

    var e = r(0),
        u = r.n(e),
        o = r(1);

    function i(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var a = u.a.string(",").trim(o.a),
        c = u.a.lazy(function () {
      var t = r(3).default,
          n = u.a.string("...").then(o.a).then(t).node("spread"),
          e = u.a.sepBy(t, a).node("simpleList");
      return u.a.sepBy(u.a.alt(n, e), a).map(function (t) {
        return {
          name: "collectionCore",
          value: t
        };
      });
    }),
        f = u.a.lazy(function () {
      var t = r(3).default,
          n = r(5).default;
      return u.a.seq(u.a.string("each").then(o.a).then(t), o.a.then(u.a.string("in")).then(o.a.then(t)), o.a.then(u.a.string("if")).then(o.a.then(t)).atMost(1), o.a.then(n).atMost(1)).map(function (t) {
        var n = i(t, 4),
            r = n[0],
            e = n[1],
            u = n[2],
            o = n[3],
            a = 1 === o.length ? {
          name: "pipe",
          value: {
            left: e,
            right: o[0]
          }
        } : e;
        return {
          name: "collectionCore",
          value: [{
            name: "spread",
            value: {
              name: "parentheses",
              value: {
                name: "pipe",
                value: {
                  left: 1 === u.length ? {
                    name: "pipe",
                    value: {
                      left: a,
                      right: {
                        name: "functionCall",
                        value: {
                          left: {
                            name: "identifier",
                            value: "filter"
                          },
                          right: {
                            name: "lambda",
                            value: {
                              variable: "input",
                              definition: u[0]
                            }
                          }
                        }
                      }
                    }
                  } : a,
                  right: {
                    name: "functionCall",
                    value: {
                      left: {
                        name: "identifier",
                        value: "map"
                      },
                      right: {
                        name: "lambda",
                        value: {
                          variable: "input",
                          definition: r
                        }
                      }
                    }
                  }
                }
              }
            }
          }]
        };
      });
    }),
        l = u.a.alt(f, c);

    n.a = function (t) {
      var n = t.name,
          r = t.open,
          e = t.close;
      return l.trim(o.a).wrap(u.a.string(r), u.a.string(e)).map(function (t) {
        return t.value;
      }).node(n).desc(n);
    };
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    var e = r(7);
    n.default = Object(e.a)({
      name: "list",
      open: "[",
      close: "]"
    });
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    var e = r(0),
        u = r.n(e),
        o = r(1);

    function i(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var a = u.a.lazy(function () {
      var t = r(3).default,
          n = r(4).default;
      return u.a.seq(n, o.a, t.atMost(1)).map(function (t) {
        var n = i(t, 3),
            r = n[0];
        n[1];
        return {
          name: "functionCall",
          value: {
            left: r,
            right: n[2][0] || null
          }
        };
      });
    }),
        c = u.a.lazy(function () {
      var t = r(3).default;
      return u.a.string("~").then(o.a).then(t).map(function (t) {
        return {
          name: "functionCall",
          value: {
            left: {
              name: "identifier",
              value: "map"
            },
            right: {
              name: "lambda",
              value: {
                variable: "input",
                definition: t
              }
            }
          }
        };
      });
    }),
        f = function f(t, n, r) {
      return u.a.lazy(function () {
        var e = n.node("primitive");
        return u.a.seq(t, u.a.seq(o.a.then(e), o.a.then(t)).many()).map(function (t) {
          return t[1].length > 0 ? {
            name: "binaryOperation",
            value: t[1].reduce(function (t, n) {
              return t.concat(n);
            }, [t[0]])
          } : t[0];
        }).desc(r);
      });
    };

    function l(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function s(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var p = [["unary", u.a.lazy(function () {
      var t = u.a.oneOf("+-!").trim(o.a).node("primitive"),
          n = r(20).default;
      return u.a.seq(t.many(), n).map(function (t) {
        var n = l(t, 2),
            r = n[0],
            e = n[1];
        return r.length > 0 ? r.reduce(function (t, n) {
          return {
            name: "unaryOperation",
            value: {
              operator: n,
              operand: t
            }
          };
        }, e) : e;
      }).desc("unaryOperator");
    })], ["multiplicative", u.a.regexp(/[*\/%]/)], ["additive", u.a.regexp(/[+-]/)], ["boolean1", u.a.regexp(/[<>]=?/)], ["boolean2", u.a.regexp(/[=!]=/).map(function (t) {
      return t + "=";
    })], ["boolean3", u.a.regexp(/(\|\||&&|or|and)/).map(function (t) {
      return "or" === t ? "||" : "and" === t ? "&&" : t;
    })]],
        v = p.slice(1).reduce(function (t, n) {
      var r = s(n, 2),
          e = r[0],
          u = r[1];
      return f(t, u, e);
    }, p[0][1]);
    n.default = u.a.alt(v, a, c);
  }, function (t, n) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    var _compiler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16),
        _builtins_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12);

    function ownKeys(t, n) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var e = Object.getOwnPropertySymbols(t);
        n && (e = e.filter(function (n) {
          return Object.getOwnPropertyDescriptor(t, n).enumerable;
        })), r.push.apply(r, e);
      }

      return r;
    }

    function _objectSpread(t) {
      for (var n = 1; n < arguments.length; n++) {
        var r = null != arguments[n] ? arguments[n] : {};
        n % 2 ? ownKeys(r, !0).forEach(function (n) {
          _defineProperty(t, n, r[n]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ownKeys(r).forEach(function (n) {
          Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
        });
      }

      return t;
    }

    function _defineProperty(t, n, r) {
      return n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t;
    }

    __webpack_exports__.a = function (sourceCode) {
      var compiledFunction = eval(Object(_compiler__WEBPACK_IMPORTED_MODULE_0__.a)(sourceCode));
      return function (t, n) {
        return compiledFunction(_objectSpread({}, _builtins_js__WEBPACK_IMPORTED_MODULE_1__.a, {}, JSON.parse(JSON.stringify(n || {}))))(t);
      };
    };
  }, function (t, n, r) {
    "use strict";

    var e = r(13),
        u = r.n(e),
        o = r(14),
        i = r(15),
        a = r.n(i);

    function c(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function f(t) {
      return function (t) {
        if (Array.isArray(t)) {
          for (var n = 0, r = new Array(t.length); n < t.length; n++) {
            r[n] = t[n];
          }

          return r;
        }
      }(t) || function (t) {
        if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
      }(t) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    var l = function l(t) {
      return void 0 === t ? null : t;
    },
        s = function s(t, n) {
      return null === l(t) ? null : n(t);
    },
        p = function p(t) {
      return Array.isArray(t) ? t.length : Object.keys(t).length;
    },
        v = JSON.parse,
        h = function h(t) {
      return t.reduce(function (t, n) {
        return t[n[0]] = n[1], t;
      }, {});
    },
        d = function d(t) {
      return function (n) {
        return n.map(function (t) {
          return function (n) {
            return Number.isInteger(n) ? l(t.slice(n)[0]) : Array.isArray(n) ? l(t.slice.apply(t, f(n))) : l(t[n]);
          };
        }(t));
      };
    };

    n.a = {
      objectify: h,
      __opt__: s,
      __spread__: function __spread__(t) {
        return Array.isArray(t) ? t : "string" == typeof t || t instanceof String ? t.split("") : Object.entries(t);
      },
      projection: function projection(t, n, r) {
        return 1 === n.length ? s(t, function () {
          return d(t)(n)[0];
        }) : s(t, function () {
          return d(t)(n);
        });
      },
      __objectProjection__: function t(n, r, e, u) {
        var o = {};
        return r.forEach(function (r) {
          var e, i;

          if ("SimpleItem" === r.type && (e = r.value, i = r.alias || e, o[i] = e in n ? n[e] : null), "FragmentItem" === r.type && Object.assign(o, u[r.value](n)), "RecursiveItem" === r.type) {
            e = r.name, i = r.alias || e;
            var a = r.value.value;
            o[i] = e in n ? t(n[e], a, 0, u) : null;
          }
        }), o;
      },
      split: function split(t) {
        return function (n) {
          return n.split(t);
        };
      },
      join: function join(t) {
        return function (n) {
          return n.join(t);
        };
      },
      map: function map(t) {
        return function (n) {
          return Array.isArray(n) ? n.map(t) : h(Object.entries(n).map(function (n) {
            var r = c(n, 2),
                e = r[0],
                u = r[1];
            return t(e)(u);
          }));
        };
      },
      sortBy: function sortBy(t) {
        return function (n) {
          return n.slice().sort(function (n, r) {
            return t(n) < t(r) ? -1 : t(n) > t(r) ? 1 : 0;
          });
        };
      },
      has: function has(t) {
        return function (n) {
          return t in n;
        };
      },
      filter: function filter(t) {
        return function (n) {
          return n.filter(t);
        };
      },
      get: function get(t) {
        return this[t];
      },
      __assign__: function __assign__(t, n, r) {
        return Object.assign({}, r, function (t, n, r) {
          return n in t ? Object.defineProperty(t, n, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[n] = r, t;
        }({}, t, n));
      },
      reverse: function reverse(t) {
        return t.slice().reverse();
      },
      reduce: function reduce(t) {
        var n = c(t, 2),
            r = n[0],
            e = n[1];
        return function (t) {
          return t.reduce(function (t, n) {
            return r(t)(n);
          }, e);
        };
      },
      length: p,
      size: p,
      keys: function keys(t) {
        return Object.keys(t);
      },
      values: function values(t) {
        return Object.values(t);
      },
      entries: function entries(t) {
        return Object.entries(t);
      },
      combinations: function combinations(t) {
        return function (n) {
          return Array.from(u()(n, t));
        };
      },
      product: function product(t) {
        return Array.from(o.product.apply(void 0, f(t)));
      },
      error: function error(t) {
        return function (n) {
          throw new Error(t);
        };
      },
      parseJSON: v,
      update: function update(t) {
        return function (n) {
          return a()(n, t);
        };
      }
    };
  }, function (t, n, r) {
    "use strict";

    (function (t) {
      !function (t) {
        t.exports =
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(t, n) {
          var r, e, u, o, i;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  void 0 === t && (t = []), void 0 === n && (n = 0);

                  for (r = [], e = t.length, u = 0, o = 0; o < n; o++) {
                    r.push(-1);
                  }

                case 2:
                  if (!(u >= 0)) {
                    _context.next = 12;
                    break;
                  }

                  if (!(r[u] < e - (n - u))) {
                    _context.next = 9;
                    break;
                  }

                  for (i = r[u] - u + 1; u < n; u++) {
                    r[u] = i + u;
                  }

                  _context.next = 7;
                  return r.map(function (n) {
                    return t[n];
                  });

                case 7:
                  _context.next = 10;
                  break;

                case 9:
                  u--;

                case 10:
                  _context.next = 2;
                  break;

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        });
      }(t);
    }).call(this, r(10)(t));
  }, function (t, n, r) {
    "use strict";

    var e = this && this.__generator || function (t, n) {
      var r,
          e,
          u,
          o,
          i = {
        label: 0,
        sent: function sent() {
          if (1 & u[0]) throw u[1];
          return u[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: a(0),
        throw: a(1),
        return: a(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function a(o) {
        return function (a) {
          return function (o) {
            if (r) throw new TypeError("Generator is already executing.");

            for (; i;) {
              try {
                if (r = 1, e && (u = 2 & o[0] ? e.return : o[0] ? e.throw || ((u = e.return) && u.call(e), 0) : e.next) && !(u = u.call(e, o[1])).done) return u;

                switch (e = 0, u && (o = [2 & o[0], u.value]), o[0]) {
                  case 0:
                  case 1:
                    u = o;
                    break;

                  case 4:
                    return i.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    i.label++, e = o[1], o = [0];
                    continue;

                  case 7:
                    o = i.ops.pop(), i.trys.pop();
                    continue;

                  default:
                    if (!(u = (u = i.trys).length > 0 && u[u.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      i = 0;
                      continue;
                    }

                    if (3 === o[0] && (!u || o[1] > u[0] && o[1] < u[3])) {
                      i.label = o[1];
                      break;
                    }

                    if (6 === o[0] && i.label < u[1]) {
                      i.label = u[1], u = o;
                      break;
                    }

                    if (u && i.label < u[2]) {
                      i.label = u[2], i.ops.push(o);
                      break;
                    }

                    u[2] && i.ops.pop(), i.trys.pop();
                    continue;
                }

                o = n.call(t, i);
              } catch (t) {
                o = [6, t], e = 0;
              } finally {
                r = u = 0;
              }
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, a]);
        };
      }
    };

    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    var u = r(21);

    n.product = function () {
      var t,
          n,
          r,
          o,
          i,
          a = [];

      for (t = 0; t < arguments.length; t++) {
        a[t] = arguments[t];
      }

      return e(this, function (t) {
        switch (t.label) {
          case 0:
            n = a.map(function (t) {
              return t.length;
            }), r = u.optimizeInd2sub(n), o = n.reduce(function (t, n) {
              return t * n;
            }, 1), i = 0, t.label = 1;

          case 1:
            return i < o ? [4, r(i).map(function (t, n) {
              return a[n][t];
            })] : [3, 4];

          case 2:
            t.sent(), t.label = 3;

          case 3:
            return i++, [3, 1];

          case 4:
            return [2];
        }
      });
    };
  }, function (t, n, r) {
    (function (t, r) {
      var e = 200,
          u = "__lodash_hash_undefined__",
          o = 800,
          i = 16,
          a = 9007199254740991,
          c = "[object Arguments]",
          f = "[object AsyncFunction]",
          l = "[object Function]",
          s = "[object GeneratorFunction]",
          p = "[object Null]",
          v = "[object Object]",
          h = "[object Proxy]",
          d = "[object Undefined]",
          y = /^\[object .+?Constructor\]$/,
          b = /^(?:0|[1-9]\d*)$/,
          g = {};
      g["[object Float32Array]"] = g["[object Float64Array]"] = g["[object Int8Array]"] = g["[object Int16Array]"] = g["[object Int32Array]"] = g["[object Uint8Array]"] = g["[object Uint8ClampedArray]"] = g["[object Uint16Array]"] = g["[object Uint32Array]"] = !0, g[c] = g["[object Array]"] = g["[object ArrayBuffer]"] = g["[object Boolean]"] = g["[object DataView]"] = g["[object Date]"] = g["[object Error]"] = g[l] = g["[object Map]"] = g["[object Number]"] = g[v] = g["[object RegExp]"] = g["[object Set]"] = g["[object String]"] = g["[object WeakMap]"] = !1;

      var m = "object" == typeof t && t && t.Object === Object && t,
          _ = "object" == typeof self && self && self.Object === Object && self,
          j = m || _ || Function("return this")(),
          w = n && !n.nodeType && n,
          O = w && "object" == typeof r && r && !r.nodeType && r,
          x = O && O.exports === w,
          E = x && m.process,
          A = function () {
        try {
          var t = O && O.require && O.require("util").types;

          return t || E && E.binding && E.binding("util");
        } catch (t) {}
      }(),
          S = A && A.isTypedArray;

      function P(t, n, r) {
        switch (r.length) {
          case 0:
            return t.call(n);

          case 1:
            return t.call(n, r[0]);

          case 2:
            return t.call(n, r[0], r[1]);

          case 3:
            return t.call(n, r[0], r[1], r[2]);
        }

        return t.apply(n, r);
      }

      var B,
          z,
          k,
          M = Array.prototype,
          I = Function.prototype,
          q = Object.prototype,
          L = j["__core-js_shared__"],
          T = I.toString,
          F = q.hasOwnProperty,
          D = (B = /[^.]+$/.exec(L && L.keys && L.keys.IE_PROTO || "")) ? "Symbol(src)_1." + B : "",
          U = q.toString,
          $ = T.call(Object),
          C = RegExp("^" + T.call(F).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          R = x ? j.Buffer : void 0,
          N = j.Symbol,
          W = j.Uint8Array,
          K = R ? R.allocUnsafe : void 0,
          J = (z = Object.getPrototypeOf, k = Object, function (t) {
        return z(k(t));
      }),
          Z = Object.create,
          G = q.propertyIsEnumerable,
          V = M.splice,
          X = N ? N.toStringTag : void 0,
          H = function () {
        try {
          var t = wt(Object, "defineProperty");
          return t({}, "", {}), t;
        } catch (t) {}
      }(),
          Q = R ? R.isBuffer : void 0,
          Y = Math.max,
          tt = Date.now,
          nt = wt(j, "Map"),
          rt = wt(Object, "create"),
          et = function () {
        function t() {}

        return function (n) {
          if (!qt(n)) return {};
          if (Z) return Z(n);
          t.prototype = n;
          var r = new t();
          return t.prototype = void 0, r;
        };
      }();

      function ut(t) {
        var n = -1,
            r = null == t ? 0 : t.length;

        for (this.clear(); ++n < r;) {
          var e = t[n];
          this.set(e[0], e[1]);
        }
      }

      function ot(t) {
        var n = -1,
            r = null == t ? 0 : t.length;

        for (this.clear(); ++n < r;) {
          var e = t[n];
          this.set(e[0], e[1]);
        }
      }

      function it(t) {
        var n = -1,
            r = null == t ? 0 : t.length;

        for (this.clear(); ++n < r;) {
          var e = t[n];
          this.set(e[0], e[1]);
        }
      }

      function at(t) {
        var n = this.__data__ = new ot(t);
        this.size = n.size;
      }

      function ct(t, n) {
        var r = Bt(t),
            e = !r && Pt(t),
            u = !r && !e && kt(t),
            o = !r && !e && !u && Tt(t),
            i = r || e || u || o,
            a = i ? function (t, n) {
          for (var r = -1, e = Array(t); ++r < t;) {
            e[r] = n(r);
          }

          return e;
        }(t.length, String) : [],
            c = a.length;

        for (var f in t) {
          !n && !F.call(t, f) || i && ("length" == f || u && ("offset" == f || "parent" == f) || o && ("buffer" == f || "byteLength" == f || "byteOffset" == f) || Ot(f, c)) || a.push(f);
        }

        return a;
      }

      function ft(t, n, r) {
        (void 0 === r || St(t[n], r)) && (void 0 !== r || n in t) || pt(t, n, r);
      }

      function lt(t, n, r) {
        var e = t[n];
        F.call(t, n) && St(e, r) && (void 0 !== r || n in t) || pt(t, n, r);
      }

      function st(t, n) {
        for (var r = t.length; r--;) {
          if (St(t[r][0], n)) return r;
        }

        return -1;
      }

      function pt(t, n, r) {
        "__proto__" == n && H ? H(t, n, {
          configurable: !0,
          enumerable: !0,
          value: r,
          writable: !0
        }) : t[n] = r;
      }

      ut.prototype.clear = function () {
        this.__data__ = rt ? rt(null) : {}, this.size = 0;
      }, ut.prototype.delete = function (t) {
        var n = this.has(t) && delete this.__data__[t];
        return this.size -= n ? 1 : 0, n;
      }, ut.prototype.get = function (t) {
        var n = this.__data__;

        if (rt) {
          var r = n[t];
          return r === u ? void 0 : r;
        }

        return F.call(n, t) ? n[t] : void 0;
      }, ut.prototype.has = function (t) {
        var n = this.__data__;
        return rt ? void 0 !== n[t] : F.call(n, t);
      }, ut.prototype.set = function (t, n) {
        var r = this.__data__;
        return this.size += this.has(t) ? 0 : 1, r[t] = rt && void 0 === n ? u : n, this;
      }, ot.prototype.clear = function () {
        this.__data__ = [], this.size = 0;
      }, ot.prototype.delete = function (t) {
        var n = this.__data__,
            r = st(n, t);
        return !(r < 0 || (r == n.length - 1 ? n.pop() : V.call(n, r, 1), --this.size, 0));
      }, ot.prototype.get = function (t) {
        var n = this.__data__,
            r = st(n, t);
        return r < 0 ? void 0 : n[r][1];
      }, ot.prototype.has = function (t) {
        return st(this.__data__, t) > -1;
      }, ot.prototype.set = function (t, n) {
        var r = this.__data__,
            e = st(r, t);
        return e < 0 ? (++this.size, r.push([t, n])) : r[e][1] = n, this;
      }, it.prototype.clear = function () {
        this.size = 0, this.__data__ = {
          hash: new ut(),
          map: new (nt || ot)(),
          string: new ut()
        };
      }, it.prototype.delete = function (t) {
        var n = jt(this, t).delete(t);
        return this.size -= n ? 1 : 0, n;
      }, it.prototype.get = function (t) {
        return jt(this, t).get(t);
      }, it.prototype.has = function (t) {
        return jt(this, t).has(t);
      }, it.prototype.set = function (t, n) {
        var r = jt(this, t),
            e = r.size;
        return r.set(t, n), this.size += r.size == e ? 0 : 1, this;
      }, at.prototype.clear = function () {
        this.__data__ = new ot(), this.size = 0;
      }, at.prototype.delete = function (t) {
        var n = this.__data__,
            r = n.delete(t);
        return this.size = n.size, r;
      }, at.prototype.get = function (t) {
        return this.__data__.get(t);
      }, at.prototype.has = function (t) {
        return this.__data__.has(t);
      }, at.prototype.set = function (t, n) {
        var r = this.__data__;

        if (r instanceof ot) {
          var u = r.__data__;
          if (!nt || u.length < e - 1) return u.push([t, n]), this.size = ++r.size, this;
          r = this.__data__ = new it(u);
        }

        return r.set(t, n), this.size = r.size, this;
      };

      var vt,
          ht = function ht(t, n, r) {
        for (var e = -1, u = Object(t), o = r(t), i = o.length; i--;) {
          var a = o[vt ? i : ++e];
          if (!1 === n(u[a], a, u)) break;
        }

        return t;
      };

      function dt(t) {
        return null == t ? void 0 === t ? d : p : X && X in Object(t) ? function (t) {
          var n = F.call(t, X),
              r = t[X];

          try {
            t[X] = void 0;
            var e = !0;
          } catch (t) {}

          var u = U.call(t);
          e && (n ? t[X] = r : delete t[X]);
          return u;
        }(t) : function (t) {
          return U.call(t);
        }(t);
      }

      function yt(t) {
        return Lt(t) && dt(t) == c;
      }

      function bt(t) {
        return !(!qt(t) || function (t) {
          return !!D && D in t;
        }(t)) && (Mt(t) ? C : y).test(function (t) {
          if (null != t) {
            try {
              return T.call(t);
            } catch (t) {}

            try {
              return t + "";
            } catch (t) {}
          }

          return "";
        }(t));
      }

      function gt(t) {
        if (!qt(t)) return function (t) {
          var n = [];
          if (null != t) for (var r in Object(t)) {
            n.push(r);
          }
          return n;
        }(t);
        var n = xt(t),
            r = [];

        for (var e in t) {
          ("constructor" != e || !n && F.call(t, e)) && r.push(e);
        }

        return r;
      }

      function mt(t, n, r, e, u) {
        t !== n && ht(n, function (o, i) {
          if (u || (u = new at()), qt(o)) !function (t, n, r, e, u, o, i) {
            var a = Et(t, r),
                c = Et(n, r),
                f = i.get(c);
            if (f) return void ft(t, r, f);
            var l = o ? o(a, c, r + "", t, n, i) : void 0,
                s = void 0 === l;

            if (s) {
              var p = Bt(c),
                  h = !p && kt(c),
                  d = !p && !h && Tt(c);
              l = c, p || h || d ? Bt(a) ? l = a : Lt(_ = a) && zt(_) ? l = function (t, n) {
                var r = -1,
                    e = t.length;
                n || (n = Array(e));

                for (; ++r < e;) {
                  n[r] = t[r];
                }

                return n;
              }(a) : h ? (s = !1, l = function (t, n) {
                if (n) return t.slice();
                var r = t.length,
                    e = K ? K(r) : new t.constructor(r);
                return t.copy(e), e;
              }(c, !0)) : d ? (s = !1, y = c, b = !0 ? (g = y.buffer, m = new g.constructor(g.byteLength), new W(m).set(new W(g)), m) : y.buffer, l = new y.constructor(b, y.byteOffset, y.length)) : l = [] : function (t) {
                if (!Lt(t) || dt(t) != v) return !1;
                var n = J(t);
                if (null === n) return !0;
                var r = F.call(n, "constructor") && n.constructor;
                return "function" == typeof r && r instanceof r && T.call(r) == $;
              }(c) || Pt(c) ? (l = a, Pt(a) ? l = function (t) {
                return function (t, n, r, e) {
                  var u = !r;
                  r || (r = {});
                  var o = -1,
                      i = n.length;

                  for (; ++o < i;) {
                    var a = n[o],
                        c = e ? e(r[a], t[a], a, r, t) : void 0;
                    void 0 === c && (c = t[a]), u ? pt(r, a, c) : lt(r, a, c);
                  }

                  return r;
                }(t, Ft(t));
              }(a) : qt(a) && !Mt(a) || (l = function (t) {
                return "function" != typeof t.constructor || xt(t) ? {} : et(J(t));
              }(c))) : s = !1;
            }

            var y, b, g, m;

            var _;

            s && (i.set(c, l), u(l, c, e, o, i), i.delete(c));
            ft(t, r, l);
          }(t, n, i, r, mt, e, u);else {
            var a = e ? e(Et(t, i), o, i + "", t, n, u) : void 0;
            void 0 === a && (a = o), ft(t, i, a);
          }
        }, Ft);
      }

      function _t(t, n) {
        return At(function (t, n, r) {
          return n = Y(void 0 === n ? t.length - 1 : n, 0), function () {
            for (var e = arguments, u = -1, o = Y(e.length - n, 0), i = Array(o); ++u < o;) {
              i[u] = e[n + u];
            }

            u = -1;

            for (var a = Array(n + 1); ++u < n;) {
              a[u] = e[u];
            }

            return a[n] = r(i), P(t, this, a);
          };
        }(t, n, $t), t + "");
      }

      function jt(t, n) {
        var r,
            e,
            u = t.__data__;
        return ("string" == (e = typeof (r = n)) || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== r : null === r) ? u["string" == typeof n ? "string" : "hash"] : u.map;
      }

      function wt(t, n) {
        var r = function (t, n) {
          return null == t ? void 0 : t[n];
        }(t, n);

        return bt(r) ? r : void 0;
      }

      function Ot(t, n) {
        var r = typeof t;
        return !!(n = null == n ? a : n) && ("number" == r || "symbol" != r && b.test(t)) && t > -1 && t % 1 == 0 && t < n;
      }

      function xt(t) {
        var n = t && t.constructor;
        return t === ("function" == typeof n && n.prototype || q);
      }

      function Et(t, n) {
        if (("constructor" !== n || "function" != typeof t[n]) && "__proto__" != n) return t[n];
      }

      var At = function (t) {
        var n = 0,
            r = 0;
        return function () {
          var e = tt(),
              u = i - (e - r);

          if (r = e, u > 0) {
            if (++n >= o) return arguments[0];
          } else n = 0;

          return t.apply(void 0, arguments);
        };
      }(H ? function (t, n) {
        return H(t, "toString", {
          configurable: !0,
          enumerable: !1,
          value: (r = n, function () {
            return r;
          }),
          writable: !0
        });
        var r;
      } : $t);

      function St(t, n) {
        return t === n || t != t && n != n;
      }

      var Pt = yt(function () {
        return arguments;
      }()) ? yt : function (t) {
        return Lt(t) && F.call(t, "callee") && !G.call(t, "callee");
      },
          Bt = Array.isArray;

      function zt(t) {
        return null != t && It(t.length) && !Mt(t);
      }

      var kt = Q || function () {
        return !1;
      };

      function Mt(t) {
        if (!qt(t)) return !1;
        var n = dt(t);
        return n == l || n == s || n == f || n == h;
      }

      function It(t) {
        return "number" == typeof t && t > -1 && t % 1 == 0 && t <= a;
      }

      function qt(t) {
        var n = typeof t;
        return null != t && ("object" == n || "function" == n);
      }

      function Lt(t) {
        return null != t && "object" == typeof t;
      }

      var Tt = S ? function (t) {
        return function (n) {
          return t(n);
        };
      }(S) : function (t) {
        return Lt(t) && It(t.length) && !!g[dt(t)];
      };

      function Ft(t) {
        return zt(t) ? ct(t, !0) : gt(t);
      }

      var Dt,
          Ut = (Dt = function Dt(t, n, r) {
        mt(t, n, r);
      }, _t(function (t, n) {
        var r = -1,
            e = n.length,
            u = e > 1 ? n[e - 1] : void 0,
            o = e > 2 ? n[2] : void 0;

        for (u = Dt.length > 3 && "function" == typeof u ? (e--, u) : void 0, o && function (t, n, r) {
          if (!qt(r)) return !1;
          var e = typeof n;
          return !!("number" == e ? zt(r) && Ot(n, r.length) : "string" == e && (n in r)) && St(r[n], t);
        }(n[0], n[1], o) && (u = e < 3 ? void 0 : u, e = 1), t = Object(t); ++r < e;) {
          var i = n[r];
          i && Dt(t, i, r, u);
        }

        return t;
      }));

      function $t(t) {
        return t;
      }

      r.exports = Ut;
    }).call(this, r(22), r(10)(t));
  }, function (t, n, r) {
    "use strict";

    var e = r(5),
        u = r(2);

    n.a = function (t) {
      var n = function (t) {
        var n = e.default.parse(t);

        if (!n.status) {
          var r = t.split("\n")[n.index.line - 1].slice(n.index.column - 1, n.index.column + 9),
              u = new SyntaxError();
          throw u.lineNumber = n.index.line, u.columnNumber = n.index.column, u.message = "Expected ".concat(n.expected.join(" or "), " on line ").concat(n.index.line, " column ").concat(n.index.column, ", found '").concat(r, "' instead"), u;
        }

        return n;
      }(t).value;

      return "(function(_) { return (function(input) { return ".concat(Object(u.default)(n), "})})");
    };
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    var e = r(11);
    n.default = e.a;
  }, function (t, n) {
    t.exports = __WEBPACK_EXTERNAL_MODULE__18__;
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    var e = r(0),
        u = r.n(e),
        o = r(1);

    function i(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    n.default = u.a.lazy(function () {
      var t = r(3).default;
      return u.a.seq(t, u.a.seq(u.a.string("if").trim(o.a).then(t), u.a.string("else").trim(o.a).then(t)).atMost(1)).map(function (t) {
        var n = i(t, 2),
            r = n[0],
            e = n[1];
        return 0 === e.length ? r : {
          name: "ternary",
          value: {
            left: r,
            middle: e[0][0],
            right: e[0][1]
          }
        };
      });
    });
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    var e = r(0),
        u = r.n(e),
        o = r(1),
        i = r(6),
        a = r(4);

    function c(t, n) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var e = Object.getOwnPropertySymbols(t);
        n && (e = e.filter(function (n) {
          return Object.getOwnPropertyDescriptor(t, n).enumerable;
        })), r.push.apply(r, e);
      }

      return r;
    }

    function f(t, n, r) {
      return n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t;
    }

    function l(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var s = function s(t) {
      return {
        value: t,
        name: "projection"
      };
    },
        p = function p(t, n) {
      switch (n.name) {
        case "projection":
          return {
            name: "projection",
            value: {
              optional: n.optional,
              left: t,
              right: n.value.value
            }
          };

        case "valueProp":
          return {
            name: "valueProp",
            value: {
              optional: "?" === n.value[0],
              left: t,
              right: "?" === n.value[0] ? n.value.slice(1) : n.value
            }
          };

        default:
          return {
            name: "objectProjection",
            value: {
              left: t,
              optional: !1,
              right: n.value
            }
          };
      }
    },
        v = u.a.regexp(/\??(\.[$A-Z_][0-9A-Z_$]*)+/i).map(function (t) {
      return {
        value: t,
        name: "valueProp"
      };
    }),
        h = u.a.lazy(function () {
      var t = u.a.alt(u.a.regex(i.a).map(function (t) {
        return t.slice(1, -1);
      }), a.default.map(function (t) {
        return t.value;
      })).map(function (t) {
        return {
          type: "SimpleItem",
          value: t
        };
      }),
          n = u.a.seq(t, o.a.then(h.atMost(1))).map(function (t) {
        return 0 === t[1].length ? t[0] : {
          type: "RecursiveItem",
          name: t[0].value,
          value: t[1][0]
        };
      }),
          r = u.a.seq(t, u.a.string(":").trim(o.a)),
          e = u.a.seq(r.atMost(1), n).map(function (t) {
        var n = l(t, 2),
            r = n[0],
            e = n[1];
        return 1 === r.length ? function (t) {
          for (var n = 1; n < arguments.length; n++) {
            var r = null != arguments[n] ? arguments[n] : {};
            n % 2 ? c(r, !0).forEach(function (n) {
              f(t, n, r[n]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : c(r).forEach(function (n) {
              Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
            });
          }

          return t;
        }({}, e, {
          alias: r[0][0].value
        }) : e;
      }),
          s = u.a.string("...").then(o.a).then(a.default).map(function (t) {
        return {
          type: "FragmentItem",
          value: t.value
        };
      });
      return u.a.sepBy(u.a.alt(e, s), u.a.string(",").atMost(1).trim(o.a)).wrap(u.a.string("{").then(o.a), o.a.then(u.a.string("}"))).map(function (t) {
        return {
          name: "objectProjection",
          value: t
        };
      });
    }),
        d = u.a.lazy(function () {
      var t = r(8).default.map(s);
      return u.a.seq(u.a.string("?").atMost(1), t).map(function (t) {
        var n = l(t, 2),
            r = n[0],
            e = n[1];
        return {
          name: "projection",
          optional: 1 === r.length,
          value: e
        };
      });
    }),
        y = u.a.lazy(function () {
      var t = r(23).default;
      return u.a.seq(t.skip(o.a), u.a.alt(d, v, h).skip(o.a).many()).map(function (t) {
        var n,
            r,
            e = l(t, 2),
            u = e[0],
            o = e[1];
        return 0 === o.length ? u : (n = l([u, o], 2), r = n[0], n[1].reduce(p, r));
      }).desc("projection");
    });

    n.default = y;
  }, function (t, n, r) {
    "use strict";

    Object.defineProperty(n, "__esModule", {
      value: !0
    }), n.ind2sub = function (t, n) {
      var r = t.reduce(function (t, n) {
        return t.concat(t[t.length - 1] * n);
      }, [1]);
      return t.map(function (t, e) {
        return Math.floor(n / r[e]) % t;
      });
    }, n.optimizeInd2sub = function (t) {
      var n = t.reduce(function (t, n) {
        return t.concat(t[t.length - 1] * n);
      }, [1]);
      return function (r) {
        return function (t, n, r) {
          return t.map(function (t, e) {
            return Math.floor(n / r[e]) % t;
          });
        }(t, r, n);
      };
    };
  }, function (t, n) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (r = window);
    }

    t.exports = r;
  }, function (t, n, r) {
    "use strict";

    r.r(n);
    var e = r(0),
        u = r.n(e),
        o = r(7),
        i = Object(o.a)({
      name: "object",
      open: "{",
      close: "}"
    }),
        a = r(6),
        c = u.a.regexp(/\.[$A-Z_][0-9A-Z_$]*/i).map(function (t) {
      return {
        name: "inputProp",
        value: t
      };
    }).desc("inputProp"),
        f = r(8),
        l = r(4),
        s = u.a.string("$").then(l.default.atMost(1)).map(function (t) {
      return {
        name: "variable",
        value: t && t.length ? "$".concat(t[0].value) : "$"
      };
    }).desc("variable"),
        p = r(1),
        v = r(3);

    function h(t, n) {
      return function (t) {
        if (Array.isArray(t)) return t;
      }(t) || function (t, n) {
        if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
        var r = [],
            e = !0,
            u = !1,
            o = void 0;

        try {
          for (var i, a = t[Symbol.iterator](); !(e = (i = a.next()).done) && (r.push(i.value), !n || r.length !== n); e = !0) {
            ;
          }
        } catch (t) {
          u = !0, o = t;
        } finally {
          try {
            e || null == a.return || a.return();
          } finally {
            if (u) throw o;
          }
        }

        return r;
      }(t, n) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    var d = u.a.alt(u.a.seq(u.a.string("$").then(l.default.atMost(1)).skip(p.a).skip(u.a.string("=>")), p.a.then(v.default)).map(function (t) {
      var n = h(t, 2),
          r = n[0],
          e = n[1];
      return {
        variable: r.length ? r[0].value : "input",
        definition: e
      };
    }), u.a.string("\\").then(p.a).then(v.default).map(function (t) {
      return {
        variable: "input",
        definition: t
      };
    })).trim(p.a).node("lambda").desc("lambda"),
        y = u.a.lazy(function () {
      var t = r(5).default;
      return u.a.seq(u.a.string("("), t, u.a.string(")")).map(function (t) {
        return {
          name: "parentheses",
          value: t[1]
        };
      }).desc("parentheses");
    });
    n.default = u.a.alt(y, f.default, i, d, c, s, a.b);
  }]);
});